/*
 * @Author: 刘小博
 * @Date: 2023-02-03 14:58:56
 * @LastEditTime: 2023-02-06 13:59:34
 * @LastEditors: 刘小博
 * @Description:
 * 档案操作管理
 */

import batchOperationRouter from './modules/batchOperationRouter'
import fileRelationshipRouter from './modules/fileRelationshipRouter'

const fileOperationManageRouter = [].concat(
  batchOperationRouter,
  fileRelationshipRouter,
)
export default fileOperationManageRouter
